<!--
     <CentroMenuItem
       :centro="{centro_obj}"
       selected
       @click="event(centro)"
     >
-->

<template>
  <div :class="'cmi-cont' + (selected ? ' cmi-selected' : '')">
    <img class="cmi-img" :src="centro_logo" @error="failed_logo" />
    <div class="cmi-name-cont">
      <div class="cmi-indent">{{ indent }}</div>
      <div class="cmi-name">{{ centro.name }}</div>
    </div>
  </div>
</template>


<style lang="scss">
 @import "@/sass/variables.scss";

 .cmi-cont {
   display: flex;
   align-items: center;
   justify-content: flex-start;
   flex-direction: row;
   flex-wrap: nowrap;
   cursor: default;
   /* border-style: solid;
      border-width: 0px 0px 0px 8px;
      border-color: $secondary; */
   padding: 8px;
 }
 .cmi-cont:hover {
   background-color: #e4e4e4;;
 }

 .cmi-selected {
   background-color: $primary;
   color: #fff;
   font-weight: bold;
   /* border-width: 0px 0px 0px 0px;
      padding-left: 8px; */
 }
 .cmi-selected:hover {
   background-color: $primary-darken1;
 }

 .cmi-name-cont {
   display: flex;
   align-items: center;
   flex-direction: row;
   flex-wrap: nowrap;
   padding-left: .5em;
 }

 .cmi-img {
   width: 96px;
   max-height: 2.8em;
   object-fit: contain;
 }

 .cmi-indent {
   color: #ddd;
   padding-right: .5em;
 }

 .cmi-name {
   
 }

 .cmi-path {
   color: rgb(177, 173, 173);
   font-size: 0.8rem;
   margin-left: 2rem;
 }
</style>


<script>
 import { mapGetters } from 'vuex';
 import { resolve_logo } from '@/utils/logos';

 export default {
   name: 'CentroMenuItem',

   props: {
     centro: Object,
     selected: {type: Boolean, default: false},
   },

   data: () => ({
     failed: false,
   }),

   computed: {
     ...mapGetters(['isAdmin']),

     depth() {
       return this.centro.path.length - 1;
     },

     indent() {
       return '―'.repeat(this.depth);
     },

     centro_logo() {
       return resolve_logo(this.centro.logo, this.failed);
     },
   },

   methods: {
     failed_logo() {
       this.failed = true;
     },
   },
 }
</script>
